import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	companyFinanceData: [],
};

const financeSlice = createSlice({
	name: "finance",
	initialState,
	reducers: {
		financeStatistic: (state, action) => {
			state.companyFinanceData = action.payload;
		},
	},
});

export const { financeStatistic } = financeSlice.actions;

export default financeSlice.reducer;
